<template>
	<div class="footers">
		<footer class="main-footer">
			<div class="row">
				<div class="columns column3 footer-div">
					<div class="footer-logo">
						<img
							src="~/assets/images/logo-barbacoa-barbecue-restaurant-2026-wit.png"
							loading="lazy"
							alt="Barbecoa - Barbecue Restaurant"
						/>
						<p class="footer-tagline">{{ defaults[locale].website.footerContent }}</p>
						<social-media :socials="socials" />

						<img
							src="~/assets/images/logo-kaddour-wit.png"
							loading="lazy"
							style="max-width: 150px; margin: 20px 0 0"
							alt="Kaddour logo"
						/>
					</div>
				</div>
				<div class="columns column3">
					<h4>{{ defaults[locale].website.restaurantName }}</h4>
					<p class="address">
						<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span>
						<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
						<span>{{ defaults[locale].website.country }}</span>

						<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
							<span>
								<font-awesome-icon class="nav-icon" icon="fal fa-phone" size="1x" />
								{{ defaults[locale].website.phone }}
							</span>
						</a>
						<a :href="`mailto:${defaults[locale].website.email}`">
							<span>
								<font-awesome-icon class="nav-icon" icon="fal fa-envelope" size="1x" />
								{{ defaults[locale].website.email }}
							</span>
						</a>
					</p>
				</div>
				<div class="columns column3">
					<h4>{{ $t('navigation') }}</h4>
					<p>
						<nuxt-link v-for="item in footermenu[locale]" :key="item.filename" :to="item.filename">
							{{ item.header }}
						</nuxt-link>
					</p>
				</div>
				<div class="columns column3">
					<h4>{{ $t('openingHours') }}</h4>
					<div class="opening-hours" v-html="defaults[locale].homepage.contactContent" />
				</div>
			</div>
		</footer>
		<footer class="author-footer">
			<div class="row">
				<div class="columns column12">
					<div class="border" />
					<p>
						<a
							href="https://www.becurious.com/"
							target="_blank"
							rel="noopener noreferrer"
							title="Hotel website design by becurious"
						>
							Website Design
						</a>
						<span>by:</span>
						<a href="https://www.becurious.com" target="_blank">
							<img src="~/assets/images/logo-becurious-white.png" loading="lazy" alt="Becurious logo" />
						</a>
					</p>
				</div>
			</div>
		</footer>
	</div>
</template>

<script setup>
const { data: footer } = await useWebsiteFetch('footermenu');
const { footermenu } = footer.value;
const { locale } = useI18n();

const { defaults, socials, fetchDefaults } = useDefaults();

await fetchDefaults();
</script>

<style lang="scss" scoped>
.footers {
	color: #fff;
	background: var(--footer-background-color);

	a,
	span {
		color: var(--footer-color);
		text-decoration: none;
	}

	h3,
	h4 {
		color: var(--footer-color);
		letter-spacing: 1px;
	}

	h4 {
		font-family: var(--heading-font-family);
		font-weight: 700;
		font-size: 1.6em;
		text-transform: uppercase;
	}
}

.main-footer {
	font-family: var(--body-font-family);
	padding: 75px 0 0;
	font-size: 11px;
	line-height: var(--small-font-line-height);
	letter-spacing: var(--small-letter-spacing);
	font-weight: 300;
	border-top: 1px solid #fff;
	border-bottom: 1px solid #fff;

	p {
		font-size: 1.1em;
		letter-spacing: 1.5%;
	}

	a,
	span {
		display: block;
	}

	a:hover {
		text-decoration: underline;
	}

	.footer-logo {
		max-width: 180px;
		margin: 0 0 30px;
	}
}

.footer-div {
	display: flex;
	justify-content: start;
}

.author-footer {
	font-size: 0.8em;
	padding: 5px 0;
	text-align: center;
	width: 100%;

	p {
		margin: 15px 0;
	}

	// .border {
	// 	background: var(--secondary-background-color);
	// 	width: 100%;
	// 	height: 1px;
	// }

	img {
		max-width: 90px;
		margin: -1px 1px 3px 2px;
	}
}

.footer-tagline {
	margin-top: 20px;
}

.nav-icon {
	margin-right: 10px;
}

@media (max-width: 1080px) {
	.footer-div {
		display: flex;
		justify-content: center;
	}

	footer .columns {
		margin: 0 auto 20px;
		width: 100%;
		text-align: center;

		.socials {
			justify-content: center;
		}
	}
}

@media (max-width: 640px) {
	.main-footer {
		padding: 30px 5px;
	}
}
</style>
